/* eslint-disable */
import { Inject, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { getQueryParametersString, parseData } from '@ups/xplat/utils';
import { map } from 'rxjs/operators';
import { firstValueFrom, Observable, of } from 'rxjs';
import {
  CertificationModel,
  EmployeeAroundPlantCriteriaDto,
  EmployeeAroundPlantDto,
  JobDto,
  LodgeReservationDto,
  ManPowerRequisitionModel,
  MPRModel,
  PendingAddressModel,
  PlantDropdownDto,
  ProspectConversionDetailsModel,
  ProspectFitModel,
  ProspectResumeModel,
  RequestedClassDto,
  SafetyModel,
  TransferComplianceManPowerDetails,
  TransferManPowerDetails,
  EmployeeJobsWorkedResult,
  IODataResult,
  ManPowerReqSupervisorDashboardDto,
  OverLappingJobAndEmployeeOrProspect,
  SaveUpdateManPowerReqDetailDto,
  VerificationOfExperienceRequestDto,
  VerificationOfExperienceResponseDto,
  JobClassDesignation,
  RequestedClassDesignation,
  DropdownEmployeeDetailDto,
  FilterData,
  BaseResponse,
  ProspectModel,
  PersonUnavailabilityDto,
  SavePersonUnavailabilityDto,
  UpdatePersonUnavailabilityDto,
} from '@ups/xplat/api/dto';

import { CommonDateFunctions } from '@ups/xplat/utils';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { RecruiterWorkload } from '../models/RecruiterWorkload';
import { appendStartDateAndEndDate } from '@ups/xplat/utils';
import * as MpEndpoints from './manpower-service.endpoints';
import {
  FilledByOption,
  ProspectSaveResult,
  RecruiterDispatchStatusCount,
  ResourceCount,
  SimilarProspect,
} from './manpower-service.types';

const GET_JOB_REQUIREMENTS_BY_EMPLOYEE =
  '/api/manpowers/jobrequirements/employee/{:EmployeeId}';
const GET_JOB_REQUIREMENTS_BY_JOB =
  '/api/manpowers/jobrequirements/job/{:JobID}/';
const GET_JOB_REQUIREMENT_DETAILS_BY_JOB =
  '/api/manpowers/jobrequirementdetails/job/{:JobID}/';
const GET_BY_LAST_WORKED = '/api/manpowers/lastworked';
const GET_EMPLOYEES_AND_PROSPECTS = '/api/manpowers/employeesAndProspects';
const GET_MPR_HISTORY = '/api/manpowers/manPowerReqHistory/{:employeeID}';
const GET_MPR_HISTORY_BY_HRREF =
  '/api/manpowers/manPowerReqHistory/byHrRef/{:hrRef}';
const GET_CURRENT_AND_UPCOMING_JOBS =
  '/api/manpowers/currentandupcomingjobs/{:VPCompany}/{:VPId}';
const GET_AVAILABLE_EMPLOYEES =
  '/api/manpowers/availableemployees/{:sJobClass}/{:startDate}/{:endDate}/{:jobNumber}/{:iCompanyID}';
const GET_EMPLOYEE_AROUND_PLANT_SEARCH_CRITERIA =
  '/api/manpowers/{:jobId}/employeesaroundplantcriteria';
const GET_EMPLOYEE_AROUND_PLANT_SEARCH_CRITERIA2 =
  '/api/manpowers/employeesaroundplantcriteria/{:plantId}';
const GET_EMPLOYEES_AROUND_PLANT =
  '/api/manpowers/plant/{:PlantID}/{:jobId}/employeesaroundplant?';
const GET_EMPLOYEES_AROUND_PLANT_ODATA =
  '/api/manpowers/employeesaroundplant-odata';
const GET_EMPLOYEES_AROUND_PLANT_PERF_ODATA =
  '/api/manpowers/employeesaroundplantperf-odata';
const GET_JOBS_EMPLOYEES_MAP = '/api/manpowers/jobs-employees-map';
const GET_JOBS_EMPLOYEES_MAP_JOB_DETAILS =
  '/api/manpowers/jobs-employees-map/job/{:jobId}/details';
const GET_JOBS_EMPLOYEES_MAP_OPENING_CANDIDATES =
  '/api/manpowers/jobs-employees-map/job/{:jobId}/opening-candidates';
const GET_UNAVAILABILITY = '/api/manpowers/unavailability';
const POST_UNAVAILABILITY = '/api/manpowers/unavailability';
const PUT_UNAVAILABILITY = '/api/manpowers/unavailability/{:id}';
const GET_ONBOARDING_DATA = '/api/manpowers/onboarding/{:ID}';
const GET_ONBOARDING_DATA_ODATA = '/api/manpowers/onboarding-odata/{:ID}';
const GET_ONBOARDING_DATA_ODATA_ALL = '/api/manpowers/onboarding-odata';
const GET_ONBOARDING_DATA_FIRST_PAGE =
  '/api/manpowers/onboarding/{:ID}/{:pageSize}';
const GET_ONBOARDING_DISPATCH_DATA =
  '/api/manpowers/onboarding/dispatchandonsite/{:ID}';
const GET_ONBOARDING_DISPATCH_DATA_ODATA =
  '/api/manpowers/onboarding-odata/dispatchandonsite/{:ID}';
const GET_ONBOARDING_COUNTS = '/api/manpowers/onboarding/counts/{:ID}';
const GET_ONBOARDING_BY_JOB_DATA = '/api/manpowers/onboarding/byjob';
const GET_ONBOARDING_ODATA_BY_JOB_DATA = '/api/manpowers/onboardingOdata/byjob';
const GET_RECRUITERS = '/api/manpowers/recruiters';
const GET_RECRUITERS_WORKLOAD = '/api/manpowers/recruiters/workloadbydate?';
const GET_JOB_REQUIREMENT_DETAILS =
  '/api/manpowers/jobrequirementdetails/{:ID}';
const SYNC_DISA_STATUS = '/api/manpowers/syncdisadata/{:ID}';
const GET_JOB_REQUIREMENT_LOGS = '/api/manpowers/logs/{:ID}';
const GET_JOB_REQUIREMENT_STATUSES = '/api/manpowers/requirementstatuses';
const PUT_SPARTAEMPLOYEE_DATA = '/api/manpowers/availableemployees/{:hrref}';
const GET_BACKGROUNDSTATUSES = '/api/manpowers/backgroundstatuses';
const GET_COMPLIANCE = '/api/manpowers/compliance';
const GET_BADGECLERK = '/api/manpowers/badgeclerk';
const GET_BADGECLERK_ODATA = '/api/manpowers/badgeclerk-odata';
const GET_BADGECLERK_ODATA_BYJOB = '/api/manpowers/badgeclerk-odata-byjob';
const PUT_EMPLOYEE_ON_MANPOWER = '/api/manpowers/requisition';
const TRANSFER_MANPOWER_DETAIL_ = '/api/manpowers/transfer?';
const GET_CRAFTS_AND_AMOUNT_BY_DISPATCH_STATUS_AND_RECRUITER =
  '/api/manpowers/recruiters/craftsAndAmount?';
const GET_REQUESTED_CLASSES_AND_AMOUNT_BY_DISPATCH_STATUS_AND_RECRUITER =
  '/api/manpowers/recruiters/requestedClassAndAmount?';
const GET_ORDERED_DISPATCH_STATUSES =
  '/api/manpowers/recruiters/getOrderedDispatchStatuses';
const ADD_OR_UPDATE_PROSPECT = '/api/manpowers/prospects/saveProspect';
const TRANSFER_MULTI_MANPOWER_DETAIL_ = '/api/manpowers/multitransfer';
const GET_JOB_REQUIREMENT_NOTES = '/api/manpowers/jobrequirementnotes/{:ID}';
const GET_ONSITE_DATA = '/api/manpowers/onsitecompliance/{:ID}';
const GET_PREONSITE_DATA = '/api/manpowers/preonsitecompliance/{:ID}';
const GET_COMPLAINCE_PREONSITE_WORKLOAD =
  '/api/manpowers/compliance/preonsite/workloadbydate?';
const GET_COMPLAINCE_ONSITE_WORKLOAD =
  '/api/manpowers/compliance/onsite/workloadbydate?';
const TRANSFER_COMPLAINCE_DETAIL = '/api/manpowers/compliance/transfer?';
const GET_COMPLAINCE_START_DATE_AND_AMOUNT =
  '/api/manpowers/compliance/preonsite/startdatesandamount?';
const GET_TAB_TOTAL_COUNT =
  '/api/manpowers/compliance/counts/{:backgroundMemberID}';
const GET_DISPATCH_STATUSES = '/api/manpowers/recruiters/getDispatchStatuses';
const GET_DECLINATION_REASONS =
  '/api/manpowers/recruiters/getDeclinationReasons';
const GET_WORKGROUPS = '/api/manpowers/workgroups';
const CONVERT_PROSPECT_TO_EMPLOYEE =
  '/api/manpowers/convertprospecttoemployee/';
const GET_EMPLOYEEPROSPECTDROPDOWN =
  '/api/spartaemployee/getemployeeandprospectdropdown?searchString={:term}';
const GET_EMDESIGNATIONS = '/api/safety/emdesignations';
const GET_EMPLOYEEDROPDOWN =
  '/api/spartaemployee/employee/dropdown?searchString={:term}';
const GET_LODGING_EMPLOYEEPROSPECTDROPDOWN =
  '/api/lodging/employeeAndProspectDropdown/{:jobID}/{:checkIn}/{:checkOut}';
const PUT_REQUESTION_BY_MANPOWERREQ_EMPID =
  '/api/manpowers/requisition/{:manPowerReqDetailID}/{:employeeOrProspectID}';
const GET_EMPLOYEEORPORSPECT_DETAILS =
  '/api/spartaemployee/employeeorprospectdetails/{:manPowerReqDetailID}/{:employeeOrProspectID}?';
const GET_MANPOWER_POSITIONS_DATA_ODATA =
  '/api/manpowers/supervisordashboard-odata/{:manPowerReqDetailID}';
const GET_PROSPECTS_DATA_ODATA =
  '/api/manpowers/{:showInactive}/prospects-odata';
const GET_PROSPECT_CLASSES = '/api/manpowers/{:showInactive}/prospectClasses';
const GET_MANPOWER_POSITIONS_DATA =
  '/api/manpowers/supervisordashboard-odata/{:manPowerReqDetailID}';
const DELETE_MANPOWER_POSITIONS = '/api/manpowers/delete';
const GET_JOBS = '/api/jobs/dropdown';
const BULK_UPDATE_MANPOWERS = '/api/manpowers/bulkUpdate';
const GET_CLASSESDROPDOWN =
  '/api/manpowers/getClassesForDropdown?jobid={:jobID}&searchString={:term}';
const GET_SIMILAR_PROSPECTS = '/api/manpowers/prospects/getSimilar/{:ID}';
const GET_MATCHING_EMPLOYEES =
  '/api/manpowers/prospects/getMatchingEmployees/{:ID}';
const MERGE_PROSPECT = '/api/manpowers/prospects/mergeProspect/{:ID}';
const GET_PLANTS = '/api/manpowers/dropdown/plants?';
const FETCH_WORKCLASSES = '/odata/workClasses';
const GET_EXPORT_ALL_SUPERVISOR_DATA =
  '/api/manpowers/supervisordashboardExportAll/{:manPowerReqDetailID}';
const GET_SCORE_CARD_DROPDOWNS_DATA =
  '/api/manpowers/scorecarddropdownsdata/{:manPowerReqDetailID}';
const GET_ALL_PLANTS_LATLONG = '/api/manpowers/fetchAllPlants';
const GET_SCORE_CARD_DATA_BY_WEEKS =
  '/api/manpowers/supervisordashboardchartdatabyweeks/{:weeksCount}';
const GET_SCORE_CARD_DATA_BY_DATES: string =
  '/api/manpowers/supervisordashboardchartdatabydates';
const GET_REQUESTED_CLASSES = '/api/manpowers/requestedClasses';
const GET_DISPATCH_CLASSES =
  '/api/manpowers/jobClasses/{:manpowerReqDetailId}/{:searchString}';
const GET_COMPLIANCE_ODATA = '/api/manpowers/compliance-odata';
const GET_COMPLIANCE_COUNTS = '/api/manpowers/compliance/counts/{:ID}';
const GET_RESOURCE_COUNTS = '/api/manpowers/resourceCounts';
const GET_RECRUITER_DISPATCH_STATUS_COUNTS =
  '/api/manpowers/recruiter/dispatchStatusCounts';
const GET_SUPERVISORS = '/api/manpowers/supervisors';
const GET_FILLEDBY = '/api/manpowers/filled-by';
const GET_FOREMANS = '/api/manpowers/foremans';
const GET_LODGING_DATA_ODATA = '/api/manpowers/lodgeReservation-odata';
const GET_LODGE_RESERVATION = '/api/lodgeReservation/{:lodgeReservationID}';
const GET_LODGE_RESERVATION_BY_MAN_POWER_ID =
  '/api/manpowers/lodgeReservation/{:manPowerReqDetailID}';
const SAVE_LODGE_RESERVATION = '/api/manpowers/lodgeReservation';
const GET_LODGES = '/api/manpowers/lodges';
const GET_EMPLOYEES_TRADECLASS_AND_LINKEDCLASSES =
  '/api/manpowers/getEmployeesTradeClassIDAndLinkedClassID/{:employeeId}';
const GET_EMPLOYEE_EMPLOYEEID = '/api/fetchEmployeeID/{:hrref}';
const GET_JOB_CLASS_ID = '/api/manpowers/getJobClassId/{:jobId}';
const GET_CURRENT_JOBS_OF_EMPLOYEE =
  '/api/manpowers/currentandupcomingjobsByHrref/{:hrref}';
const SEARCH_EMPLOYEES =
  '/api/manpowers/search-candidates-for-manpowerreqdetail-odata?';
const GET_REGIONS = '/api/region';

@Injectable({
  providedIn: 'root',
})
export class ManPowerService {
  spartaApiHttpDefault: HttpClient;
  spartaApiHttpPascal: HttpClient;
  spartaApiHttpCamel: HttpClient;
  datePipe: DatePipe = new DatePipe('en-US');

  constructor(httpFactory: MyHttpClientFactory) {
    this.spartaApiHttpDefault = httpFactory.createHttpClient(
      environment.urls.spartaAPI
    );
    this.spartaApiHttpPascal = httpFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
    this.spartaApiHttpCamel = httpFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  public fetchJobRequirementStatuses(): Promise<any[]> {
    var url = GET_JOB_REQUIREMENT_STATUSES;
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .pipe(map(parseData))
      .toPromise();
  }

  public fetchEmployeeID(hrref: any) {
    var url = GET_EMPLOYEE_EMPLOYEEID.split('{:hrref}').join(hrref);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((res) => JSON.parse((res as HttpResponse<any>).body)))
      .toPromise();
  }

  public fetchJobClassID(jobId: any) {
    var url = GET_JOB_CLASS_ID.split('{:jobId}').join(jobId);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((res) => JSON.parse((res as HttpResponse<any>).body)));
  }

  public syncDisaStatus(manpowerReqDetailId: string): Observable<any> {
    var url = SYNC_DISA_STATUS.split('{:ID}').join(manpowerReqDetailId);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchAllPlantsLatLong(): Observable<any> {
    var url = GET_ALL_PLANTS_LATLONG;
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchJobRequirementDetails(
    manpowerReqDetailId: string
  ): Observable<any> {
    var url =
      GET_JOB_REQUIREMENT_DETAILS.split('{:ID}').join(manpowerReqDetailId);
    // var url = 'config/jobReqDetails.json';
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchJobRequirementLogs(manpowerReqDetailId: string): Observable<any> {
    var url = GET_JOB_REQUIREMENT_LOGS.split('{:ID}').join(manpowerReqDetailId);
    //var url = 'config/jobReqDetails.json';
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchBackgroundStatuses() {
    var url = GET_BACKGROUNDSTATUSES;
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((res) => JSON.parse((res as HttpResponse<any>).body)))
      .toPromise();
  }

  public fetchCompliance(): Observable<unknown> {
    var url = GET_COMPLIANCE;
    return this.spartaApiHttpDefault
      .get<unknown>(url)
      .pipe(map((response) => parseData(response)));
  }

  public fetchBadgeClerk(): Observable<unknown> {
    var url = GET_BADGECLERK;
    return this.spartaApiHttpDefault
      .get<unknown>(url)
      .pipe(map((response) => parseData(response)));
  }

  public fetchBadgeClerkOdata(odataString: string): Observable<any> {
    var url = GET_BADGECLERK_ODATA;

    // solution to defect #19916 in Badge Clerk Dashboard
    odataString = odataString.replace("tolower('Blank')", 'null');

    url += '?$format=json&$count=true';
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((response) => parseData(response)));
  }

  public fetchBadgeClerkOdataByJob(
    jobs: string[],
    odataString: string
  ): Observable<any> {
    var url = GET_BADGECLERK_ODATA_BYJOB + '?jobNumbers=' + jobs;

    url += '&$format=json&$count=true';
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((response) => parseData(response)));
  }

  public fetchRecruiters(): Observable<any> {
    var url = GET_RECRUITERS;
    return this.spartaApiHttpDefault.get(url);
  }

  public fetchRecruitersWorkloadByDate(
    startDate: string,
    endDate: string,
    regionId?: string
  ) {
    let url = appendStartDateAndEndDate(
      GET_RECRUITERS_WORKLOAD,
      startDate,
      endDate
    );

    if (regionId) {
      if (startDate || endDate) {
        url += '&';
      }
      url += `regionId=${regionId}`;
    }

    return this.spartaApiHttpDefault.get<RecruiterWorkload[]>(url);
  }

  public fetchOnboardingData(recruiterId: string): Observable<any> {
    var url = GET_ONBOARDING_DATA.split('{:ID}').join(recruiterId);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingDataOdata(
    recruiterId: string,
    odatastring: string
  ): Observable<any> {
    var url = GET_ONBOARDING_DATA_ODATA.split('{:ID}').join(recruiterId);

    url += '?$format=json&$count=true';
    url += odatastring ? '&' + odatastring : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingDataOdataAll(
    recruiterId: string,
    inprocessEnum: any,
    odatastring: string,
    includeEmployeesWithNoMissingRequirements = false,
    includeEmployeesFromProcessOrDispatchTab = false
  ): Observable<any> {
    let url =
      GET_ONBOARDING_DATA_ODATA_ALL +
      '?recruiterID=' +
      recruiterId +
      '&showAllDispatched=' +
      includeEmployeesWithNoMissingRequirements +
      '&selectedQuery=' +
      inprocessEnum +
      '&includeEmployeesFromProcessOrDispatchTab=' +
      includeEmployeesFromProcessOrDispatchTab +
      '&';

    url += '$format=json&$count=true';
    url += odatastring ? '&' + odatastring : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingDataFirstPage(
    recruiterId: string,
    pageSize: number
  ): Observable<any> {
    var url = GET_ONBOARDING_DATA_FIRST_PAGE.split('{:ID}')
      .join(recruiterId)
      .split('{:pageSize}')
      .join(pageSize.toString());

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingDispatchData(recruiterId: string): Observable<any> {
    var url = GET_ONBOARDING_DISPATCH_DATA.split('{:ID}').join(recruiterId);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingDispatchDataOdata(
    recruiterId: string,
    odatastring: string
  ): Observable<any> {
    var url =
      GET_ONBOARDING_DISPATCH_DATA_ODATA.split('{:ID}').join(recruiterId);
    url = url + odatastring;
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingCounts(recruiterId: string): Observable<any> {
    var url = GET_ONBOARDING_COUNTS.split('{:ID}').join(recruiterId);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingByJobData(jobs: string[]): Observable<any> {
    let url = GET_ONBOARDING_BY_JOB_DATA;
    return this.spartaApiHttpDefault
      .post(url, jobs)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnboardingOdataByJobData(
    jobs: string[],
    facilityNumbers: number[],
    odatastring: string
  ): Observable<any> {
    let url = GET_ONBOARDING_ODATA_BY_JOB_DATA;
    if (jobs[0] !== null) {
      url += '?jobNumbers=' + jobs;
    } else if (facilityNumbers[0] !== null) {
      url += '?facilityNumbers=' + facilityNumbers;
    }

    url += '&$format=json&$count=true';
    url += odatastring ? '&' + odatastring : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchEmployeeProspectDropdown(
    term: string,
    take: number = 0,
    allPRGroups: boolean = false,
    requestedClassName: string = null,
    excludeInactive: boolean = false,
    includeAssignmentStatus: boolean = false
  ): Observable<any> {
    if (term && term.length > 2) {
      var url = GET_EMPLOYEEPROSPECTDROPDOWN.split('{:term}').join(term);

      if (allPRGroups === true) url += '&allPRGroups=true';

      if (requestedClassName)
        url += '&requestedClassName=' + requestedClassName;

      if (take) url += '&take=' + take;

      // WI 31264: opt-in, set only by the RA Allocation Scheduler "Available People"
      // surface so terminated employees are excluded; other callers omit it.
      if (excludeInactive === true) url += '&excludeInactive=true';

      // WI 31267: opt-in, set only by the RA "Available People" surface so currently-
      // assigned employees are flagged (CurrentAssignment); other callers omit it.
      if (includeAssignmentStatus === true)
        url += '&includeAssignmentStatus=true';

      return this.spartaApiHttpDefault
        .get(url)
        .pipe(map((data) => parseData(data)));
    } else {
      return of([]);
    }
  }

  /**
   * Unfiltered employee+prospect pool (no search term), capped by take. Same endpoint
   * and row shape as fetchEmployeeProspectDropdown; the server treats an empty
   * searchString as "no name filter". Employees come before prospects in the result,
   * so a small take can exhaust before any prospect appears.
   */
  public fetchEmployeeProspectPool(
    take: number,
    allPRGroups: boolean = false,
    excludeInactive: boolean = false,
    includeAssignmentStatus: boolean = false
  ): Observable<any> {
    var url = GET_EMPLOYEEPROSPECTDROPDOWN.split('{:term}').join('');

    if (allPRGroups === true) url += '&allPRGroups=true';
    if (take) url += '&take=' + take;
    // WI 31264: opt-in, set only by the RA Allocation Scheduler "Available People"
    // pool so terminated employees are excluded; other callers omit it.
    if (excludeInactive === true) url += '&excludeInactive=true';
    // WI 31267: opt-in, set only by the RA "Available People" pool so currently-assigned
    // employees are flagged (CurrentAssignment); other callers omit it.
    if (includeAssignmentStatus === true)
      url += '&includeAssignmentStatus=true';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  /**
   * Full EMDesignation lookup list (G40, CORE, Open Field, …) from the Sparta
   * designation table — the complete set, not just designations present in a
   * pool. Rows carry Name + EmployeeDesignationId.
   */
  public fetchEmployeeDesignations(): Observable<
    { Name: string; EmployeeDesignationId: number }[]
  > {
    return this.spartaApiHttpDefault
      .get<
        { Name: string; EmployeeDesignationId: number }[]
      >(GET_EMDESIGNATIONS)
      .pipe(map((data) => parseData(data)));
  }

  /**
   * Fill in the craft on a requisition detail that has none. The server rejects the
   * call when the row already carries a craft, so this can never overwrite one.
   */
  public setCraftOnEmptyManPower(
    manPowerReqDetailId: string,
    jobClassId: number
  ): Observable<any> {
    const url = `${PUT_EMPLOYEE_ON_MANPOWER}/${manPowerReqDetailId}/craft/${jobClassId}`;
    return this.spartaApiHttpDefault
      .put(url, null)
      .pipe(map((response) => parseData(response)));
  }

  /**
   * Narrow guarded edit of a position's dates/shift (Resource Allocation workspace).
   * Server-enforced: the row must be unassigned or on Hold, and the caller needs PM
   * Dashboard edit rights or to be the job's project manager. Only the provided
   * fields change; date strings are yyyy-MM-dd (date-only, no timezone drift).
   */
  public editEligiblePosition(
    manPowerReqDetailId: string,
    changes: {
      startDate?: string | null;
      endDate?: string | null;
      shift?: number | null;
    }
  ): Observable<any> {
    const url = `${PUT_EMPLOYEE_ON_MANPOWER}/${manPowerReqDetailId}/position`;
    return this.spartaApiHttpDefault
      .put(url, {
        StartDate: changes.startDate ?? null,
        EndDate: changes.endDate ?? null,
        Shift: changes.shift ?? null,
      })
      .pipe(map((response) => parseData(response)));
  }

  public fetchEmployeeDropdown(
    term: string,
    take: number = 0,
    vpCompanyID: number = null
  ): Observable<DropdownEmployeeDetailDto[]> {
    if (term && term.length > 2) {
      let url = GET_EMPLOYEEDROPDOWN.split('{:term}').join(term);

      if (vpCompanyID) {
        url += `&vpCompanyID=${vpCompanyID}`;
      }

      if (take) {
        url += '&take=' + take;
      }

      return this.spartaApiHttpDefault
        .get<DropdownEmployeeDetailDto[]>(url)
        .pipe(map((data) => parseData(data)));
    } else {
      return of([]);
    }
  }

  public fetchLodgingEmployeeProspectDropdown(
    jobID: string,
    checkIn: string,
    checkOut: string,
    search: string,
    take: number = 0
  ): Observable<any> {
    let url = GET_LODGING_EMPLOYEEPROSPECTDROPDOWN.split('{:jobID}')
      .join(jobID)
      .split('{:checkIn}')
      .join(checkIn)
      .split('{:checkOut}')
      .join(checkOut);

    url += '?take=' + take;

    if (search) url += '&searchString=' + search;

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchClassesDropdown(
    jobid: any,
    term: string,
    minLength: number = 3
  ): Observable<any> {
    if (term && term.length >= minLength) {
      var url = GET_CLASSESDROPDOWN.split('{:jobID}')
        .join(jobid)
        .split('{:term}')
        .join(term);

      return this.spartaApiHttpDefault
        .get(url)
        .pipe(map((data) => parseData(data)));
    } else {
      return of([]);
    }
  }

  public getPersonByReqEmpId(
    manPowerReqDetailID: string,
    employeeOrProspectID: string,
    jobStart: Date | null,
    jobEnd: Date | null
  ): Observable<OverLappingJobAndEmployeeOrProspect> {
    let url = GET_EMPLOYEEORPORSPECT_DETAILS.split(
      '{:manPowerReqDetailID}'
    ).join(manPowerReqDetailID);
    url = url.split('{:employeeOrProspectID}').join(employeeOrProspectID);

    const queryParameters: string[] = [];
    if (jobStart) {
      queryParameters.push(
        `startDate=${this.datePipe.transform(jobStart, 'MM/dd/yyyy')}`
      );
    }

    if (jobEnd) {
      queryParameters.push(
        `endDate=${this.datePipe.transform(jobEnd, 'MM/dd/yyyy')}`
      );
    }

    url = url + queryParameters.join('&');

    return this.spartaApiHttpDefault.get(
      url
    ) as Observable<OverLappingJobAndEmployeeOrProspect>;
  }

  public putRequestionByManpowerReqEmpId(
    manPowerReqDetailID: string,
    employeeOrProspectID: string,
    rehireStatus: string = null
  ) {
    var url = PUT_REQUESTION_BY_MANPOWERREQ_EMPID.split(
      '{:manPowerReqDetailID}'
    ).join(manPowerReqDetailID);
    url = url.split('{:employeeOrProspectID}').join(employeeOrProspectID);
    if (rehireStatus) url = url + '/' + rehireStatus;

    return this.spartaApiHttpDefault.put(url, {}).toPromise();
  }

  public putSpartaEmployeeAddressInPending(
    employeeAddressPending: PendingAddressModel,
    hrref: string
  ) {
    var url = PUT_SPARTAEMPLOYEE_DATA.split('{:hrref}').join(hrref);

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.spartaApiHttpDefault
      .put(url, employeeAddressPending, options)
      .toPromise()
      .then(parseData);
  }

  public getJobRequirementsByEmployee(employeeId: string) {
    var url =
      GET_JOB_REQUIREMENTS_BY_EMPLOYEE.split('{:EmployeeId}').join(employeeId);
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public getJobRequirementsByJob(jobid: string) {
    var url = GET_JOB_REQUIREMENTS_BY_JOB.split('{:JobID}').join(jobid);
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public getJobRequirementDetailsByJob(jobid: string) {
    var url = GET_JOB_REQUIREMENT_DETAILS_BY_JOB.split('{:JobID}').join(jobid);
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public getByLastWorked() {
    return this.spartaApiHttpDefault
      .get(GET_BY_LAST_WORKED)
      .toPromise()
      .then(parseData);
  }

  public getEmployeesAndProspects() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.spartaApiHttpDefault
      .get(GET_EMPLOYEES_AND_PROSPECTS)
      .toPromise()
      .then(parseData);
  }

  public getWorkedByEmp(
    HRRef: string | number,
    includeStepUp: boolean = false,
    billableOnly: boolean = false
  ): Observable<EmployeeJobsWorkedResult[]> {
    const params: string[] = [];
    if (includeStepUp) params.push('includeStepUp=true');
    if (billableOnly) params.push('billableOnly=true');
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    const url = `/api/manpowers/jobsworked/${HRRef}${queryString}`;
    return this.spartaApiHttpPascal.get(url) as Observable<
      EmployeeJobsWorkedResult[]
    >;
  }

  public sendEmailForVerificationOfExperience(
    hrRef: number,
    reason: string,
    responseDueDate: Date
  ): Observable<VerificationOfExperienceResponseDto[]> {
    const url = `/api/manpowers/verificationofexperience`;
    return this.spartaApiHttpCamel.post(url, {
      responseDueDate: responseDueDate,
      reason: reason,
      hrRef: hrRef,
    } as VerificationOfExperienceRequestDto) as Observable<
      VerificationOfExperienceResponseDto[]
    >;
  }

  public GetManPowerReqHistory(employeeID: string) {
    let url = GET_MPR_HISTORY.split('{:employeeID}').join(employeeID);
    return this.spartaApiHttpDefault
      .get<MPRModel[]>(url)
      .toPromise()
      .then(parseData);
  }

  public GetManPowerReqHistoryByHRRef(hrRef: number) {
    let url = GET_MPR_HISTORY_BY_HRREF.split('{:hrRef}').join(hrRef.toString());
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public getCurrentAndUpcomingJobs(vpid: string, vpCompany: string) {
    var url = GET_CURRENT_AND_UPCOMING_JOBS.split('{:VPId}').join(vpid);
    url = url.split('{:VPCompany}').join(vpCompany);

    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  /**
   * @deprecated This method has been moved to @ups/xplat/features/employee-profile/services/employee-jobs-service
   */
  public getCurrentAndUpcomingJobsByHRREf(hrref: string): Promise<any[]> {
    var url = GET_CURRENT_JOBS_OF_EMPLOYEE.split('{:hrref}').join(hrref);
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .toPromise()
      .then(parseData);
  }

  public saveJobRequirementDetails(
    manpowerReqDetailId: string,
    o: any
  ): Promise<{ HasError: boolean; Message?: string }> {
    var url =
      GET_JOB_REQUIREMENT_DETAILS.split('{:ID}').join(manpowerReqDetailId);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.spartaApiHttpDefault
      .put<{ HasError: boolean; Message?: string }>(url, o, options)
      .toPromise()
      .then(parseData);
  }

  public getAvailableEmployees(
    jobClass: string,
    startDate: string,
    endDate: string,
    jobNumber: string,
    iCompanyID: string = '0'
  ) {
    var url = GET_AVAILABLE_EMPLOYEES.split('{:sJobClass}').join(jobClass);
    url = url.split('{:startDate}').join(startDate);
    url = url.split('{:endDate}').join(endDate);
    url = url.split('{:jobNumber}').join(jobNumber);
    url = url.split('{:iCompanyID}').join(iCompanyID);
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public getEmployeeAroundPlantSearchCriteria(
    jobId: string,
    plantId: string
  ): Observable<EmployeeAroundPlantCriteriaDto[]> {
    var url = jobId
      ? GET_EMPLOYEE_AROUND_PLANT_SEARCH_CRITERIA.split('{:jobId}').join(jobId)
      : GET_EMPLOYEE_AROUND_PLANT_SEARCH_CRITERIA2.split('{:plantId}').join(
          plantId
        );
    return this.spartaApiHttpCamel
      .get<EmployeeAroundPlantCriteriaDto[]>(url)
      .pipe(map((response) => parseData(response)));
  }

  public getEmployeesAroundPlant(
    plantID: number,
    jobId: string,
    milesRange: number,
    vpCompanyIDs: number[],
    employeeDesignationIDs: number[],
    jobClassIDs: string[],
    classNames: string[],
    startDate: Date,
    endDate: Date,
    workedSinceDate: Date
  ): Observable<EmployeeAroundPlantDto[]> {
    var url = GET_EMPLOYEES_AROUND_PLANT.split('{:PlantID}')
      .join(plantID.toString())
      .split('{:jobId}')
      .join(jobId ? jobId.toString() : '');
    url += getQueryParametersString(
      {
        milesRange: milesRange,
        vpCompanyIDsCommaDelimited:
          vpCompanyIDs == null ? null : vpCompanyIDs.join(','),
        employeeDesignationIDsCommaDelimited:
          employeeDesignationIDs == null
            ? null
            : employeeDesignationIDs.join(','),
        jobClassIDsCommaDelimited:
          jobClassIDs == null ? null : jobClassIDs.join(','),
        classNamesCommaDelimited:
          classNames == null ? null : encodeURIComponent(classNames.join(',')),
        startDate: CommonDateFunctions.ToDateString(startDate),
        endDate: CommonDateFunctions.ToDateString(endDate),
        workedSinceDate: CommonDateFunctions.ToDateString(workedSinceDate),
      },
      true
    );

    return this.spartaApiHttpCamel
      .get<EmployeeAroundPlantDto[]>(url)
      .pipe(map((response) => parseData(response)));
  }

  public transferManPowerDetail(
    transferManPowerDetails: TransferManPowerDetails,
    startDate: string | null | undefined,
    endDate: string | null | undefined
  ) {
    let url = appendStartDateAndEndDate(
      TRANSFER_MANPOWER_DETAIL_,
      startDate,
      endDate
    );
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferManPowerDetails);
    return this.spartaApiHttpDefault.put(url, body, options).toPromise();
  }

  public getEmployeesTradeClassAndLinkedClasses(employeeId: any) {
    let url =
      GET_EMPLOYEES_TRADECLASS_AND_LINKEDCLASSES.split('{:employeeId}').join(
        employeeId
      );
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.spartaApiHttpDefault
      .get(url, options)
      .toPromise()
      .then(parseData);
  }

  public getOrderedDispatchStatuses() {
    let url = GET_ORDERED_DISPATCH_STATUSES;
    return this.spartaApiHttpDefault.get(url).toPromise();
  }

  public getCraftsAndAmountByDispatchStatusAndRecruiter(
    transferManPowerDetails: TransferManPowerDetails,
    startDate: string | null | undefined,
    endDate: string | null | undefined,
    regionId?: string
  ): Promise<BaseResponse<JobClassDesignation[]>> {
    let url = appendStartDateAndEndDate(
      GET_CRAFTS_AND_AMOUNT_BY_DISPATCH_STATUS_AND_RECRUITER,
      startDate,
      endDate
    );

    if (regionId) {
      if (startDate || endDate) {
        url += '&';
      }
      url += `regionId=${regionId}`;
    }

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferManPowerDetails);
    return firstValueFrom(
      this.spartaApiHttpDefault.put<BaseResponse<JobClassDesignation[]>>(
        url,
        body,
        options
      )
    );
  }

  public getRequestedClassesAndAmountByDispatchStatusAndRecruiter(
    transferManPowerDetails: TransferManPowerDetails,
    startDate: string | null | undefined,
    endDate: string | null | undefined,
    regionId?: string
  ): Promise<BaseResponse<RequestedClassDesignation[]>> {
    let url = appendStartDateAndEndDate(
      GET_REQUESTED_CLASSES_AND_AMOUNT_BY_DISPATCH_STATUS_AND_RECRUITER,
      startDate,
      endDate
    );

    if (regionId) {
      if (startDate || endDate) {
        url += '&';
      }
      url += `regionId=${regionId}`;
    }

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferManPowerDetails);
    return firstValueFrom(
      this.spartaApiHttpDefault.put<BaseResponse<RequestedClassDesignation[]>>(
        url,
        body,
        options
      )
    );
  }

  public requisitionEmployeeOnManPower(
    o: ManPowerRequisitionModel = null
  ): Observable<any> {
    var url = PUT_EMPLOYEE_ON_MANPOWER;

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.spartaApiHttpDefault
      .put(url, o, options)
      .pipe(map((response) => parseData(response)));
  }

  public fetchProspectLists() {
    var url = MpEndpoints.GET_PROSOECTLISTS;
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public fetchProspectData(id: string): Promise<ProspectModel> {
    var url = MpEndpoints.GET_PROSPECT_DATA.split('{:ID}').join(id);
    return this.spartaApiHttpDefault
      .get<ProspectModel>(url)
      .toPromise()
      .then(parseData);
  }

  public getProspectCert(id: string): Promise<CertificationModel[]> {
    const url = MpEndpoints.GET_PROSPECT_CERT.split('{:ID}').join(id);

    return this.spartaApiHttpDefault
      .get<CertificationModel[]>(url)
      .toPromise()
      .then(parseData);
  }

  public createProspectCert(
    item: CertificationModel
  ): Promise<CertificationModel> {
    return this.spartaApiHttpDefault
      .put<CertificationModel>(MpEndpoints.PUT_PROSPECT_CERT, item)
      .toPromise()
      .then(parseData);
  }

  public updateProspectCert(
    item: CertificationModel
  ): Promise<CertificationModel> {
    return this.spartaApiHttpDefault
      .post<CertificationModel>(MpEndpoints.POST_PROSPECT_CERT, item)
      .toPromise()
      .then(parseData);
  }

  public getProspectResumes(id: string): Promise<ProspectResumeModel[]> {
    const url = MpEndpoints.GET_PROSPECT_RESUME.split('{:ID}').join(id);

    return this.spartaApiHttpDefault
      .get<ProspectResumeModel[]>(url)
      .toPromise()
      .then(parseData);
  }

  public createProspectResume(
    item: ProspectResumeModel
  ): Promise<ProspectResumeModel> {
    return this.spartaApiHttpDefault
      .post<ProspectResumeModel>(MpEndpoints.POST_PROSPECT_RESUME, item)
      .toPromise()
      .then(parseData);
  }

  public updateProspectResume(
    item: ProspectResumeModel
  ): Promise<ProspectResumeModel> {
    return this.spartaApiHttpDefault
      .put<ProspectResumeModel>(MpEndpoints.PUT_PROSPECT_RESUME, item)
      .toPromise()
      .then(parseData);
  }

  public getProspectSafety(id: string): Promise<SafetyModel[]> {
    const url = MpEndpoints.GET_PROSPECT_SAFETY.split('{:ID}').join(id);

    return this.spartaApiHttpDefault
      .get<SafetyModel[]>(url)
      .toPromise()
      .then(parseData);
  }

  public createProspectSafety(item: SafetyModel): Promise<SafetyModel> {
    return this.spartaApiHttpDefault
      .put<SafetyModel>(MpEndpoints.PUT_PROSPECT_SAFETY, item)
      .toPromise()
      .then(parseData);
  }

  public updateProspectSafety(item: SafetyModel): Promise<SafetyModel> {
    return this.spartaApiHttpDefault
      .post<SafetyModel>(MpEndpoints.POST_PROSPECT_SAFETY, item)
      .toPromise()
      .then(parseData);
  }

  public getProspectFit(id: string): Promise<ProspectFitModel[]> {
    const url = MpEndpoints.GET_PROSPECT_FIT.split('{:ID}').join(id);

    return this.spartaApiHttpDefault
      .get<ProspectFitModel[]>(url)
      .toPromise()
      .then(parseData);
  }

  public createProspectFit(item: ProspectFitModel): Promise<ProspectFitModel> {
    return this.spartaApiHttpDefault
      .put<ProspectFitModel>(MpEndpoints.PUT_PROSPECT_FIT, item)
      .toPromise()
      .then(parseData);
  }

  public updateProspectFit(item: ProspectFitModel): Promise<ProspectFitModel> {
    return this.spartaApiHttpDefault
      .post<ProspectFitModel>(MpEndpoints.POST_PROSPECT_FIT, item)
      .toPromise()
      .then(parseData);
  }

  public saveProspect(
    prospectModel: ProspectModel
  ): Promise<ProspectSaveResult> {
    let url = ADD_OR_UPDATE_PROSPECT;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(prospectModel);
    return this.spartaApiHttpDefault
      .put<ProspectSaveResult>(url, body, options)
      .toPromise()
      .then(parseData);
  }

  public fetchDispatchStatuses(): Promise<any[]> {
    var url = GET_DISPATCH_STATUSES;
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .pipe(map(parseData))
      .toPromise();
  }

  public fetchDeclinationReasons(): Promise<any[]> {
    var url = GET_DECLINATION_REASONS;
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .pipe(map(parseData))
      .toPromise();
  }

  public fetchWorkgroups() {
    var url = GET_WORKGROUPS;
    return this.spartaApiHttpDefault.get(url).pipe(map(parseData)).toPromise();
  }

  public transferMultiManPowerDetail(
    transferManPowerDetails: TransferManPowerDetails[]
  ) {
    let url = TRANSFER_MULTI_MANPOWER_DETAIL_;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferManPowerDetails);
    return this.spartaApiHttpDefault.put(url, body, options).toPromise();
  }

  public fetchJobRequirementNotes(
    manpowerReqDetailId: string
  ): Observable<any> {
    var url =
      GET_JOB_REQUIREMENT_NOTES.split('{:ID}').join(manpowerReqDetailId);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchOnSiteData(memberId: string): Observable<any> {
    var url = GET_ONSITE_DATA.split('{:ID}').join(memberId);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchPreOnSiteData(memberId: string): Observable<any> {
    var url = GET_PREONSITE_DATA.split('{:ID}').join(memberId);
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchComplaincePreonsiteWorkloadByDate(
    startDate: string,
    endDate: string
  ) {
    console.debug('fetchComplaincePreonsiteWorkloadByDate', startDate, endDate);
    let url = appendStartDateAndEndDate(
      GET_COMPLAINCE_PREONSITE_WORKLOAD,
      startDate,
      endDate
    );
    // return this.http.get(url).pipe(map((res) => JSON.parse((res as HttpResponse<any>).body)));
    return this.spartaApiHttpDefault.get(url);
  }

  public fetchComplainceOnsiteWorkloadByDate(
    startDate: string,
    endDate: string
  ) {
    let url = appendStartDateAndEndDate(
      GET_COMPLAINCE_ONSITE_WORKLOAD,
      startDate,
      endDate
    );
    // return this.http.get(url).pipe(map((res) => JSON.parse((res as HttpResponse<any>).body)));
    return this.spartaApiHttpDefault.get(url);
  }

  public transferComplianceManPowerDetails(
    transferComplianceManPowerDetails: TransferComplianceManPowerDetails,
    startDate: string | null | undefined,
    endDate: string | null | undefined
  ) {
    let url = appendStartDateAndEndDate(
      TRANSFER_COMPLAINCE_DETAIL,
      startDate,
      endDate
    );
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferComplianceManPowerDetails);
    return this.spartaApiHttpDefault.put(url, body, options).toPromise();
  }

  public bulkUpdateManPowerDetails(dto: any) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(dto);
    return this.spartaApiHttpDefault
      .post(BULK_UPDATE_MANPOWERS, body, options)
      .toPromise()
      .then(parseData);
  }

  public getComplainceStartDatesAndAmount(
    transferComplianceManPowerDetails: TransferComplianceManPowerDetails,
    startDate: string,
    endDate: string
  ) {
    var url = appendStartDateAndEndDate(
      GET_COMPLAINCE_START_DATE_AND_AMOUNT,
      startDate,
      endDate
    );
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(transferComplianceManPowerDetails);
    return this.spartaApiHttpDefault
      .put(url, body, options)
      .toPromise()
      .then(parseData);
  }

  public fetchTabTotalCount(memberId) {
    var url = GET_TAB_TOTAL_COUNT.split('{:backgroundMemberID}').join(memberId);
    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public handleSuccess(data: any) {
    // console.log(data);
  }

  public convertProspectToEmployee(
    prospectConversionDetails: ProspectConversionDetailsModel
  ) {
    var url = CONVERT_PROSPECT_TO_EMPLOYEE;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.spartaApiHttpDefault
      .put(url, prospectConversionDetails, options)
      .toPromise()
      .then(parseData);
  }

  public handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public fetchManpowerPositionsData(
    manpowerReqDetailId: string
  ): Observable<IODataResult<ManPowerReqSupervisorDashboardDto[]>> {
    var url = GET_MANPOWER_POSITIONS_DATA.split('{:manPowerReqDetailID}').join(
      manpowerReqDetailId
    );
    return this.spartaApiHttpDefault.get(url) as Observable<
      IODataResult<ManPowerReqSupervisorDashboardDto[]>
    >;
  }

  public deleteManpowerPositions(manpowers: any) {
    let url = DELETE_MANPOWER_POSITIONS;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(manpowers);
    return this.spartaApiHttpDefault
      .put(url, body, options)
      .toPromise()
      .then(parseData);
  }

  public queryProspectsData(
    activeOnly: boolean,
    odataString: string
  ): Observable<any> {
    var url = GET_PROSPECTS_DATA_ODATA.split('{:showInactive}').join(
      activeOnly.toString()
    );

    url += '?$format=json&$count=true';
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public queryProspectClasses(activeOnly: boolean): Observable<any> {
    let url = GET_PROSPECT_CLASSES.split('{:showInactive}').join(
      activeOnly.toString()
    );

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public queryManpowerPositionsData(
    manpowerReqDetailId: string,
    odataString: string,
    activeJobsOnly: boolean = true
  ): Observable<IODataResult<ManPowerReqSupervisorDashboardDto>> {
    var url = GET_MANPOWER_POSITIONS_DATA_ODATA.split(
      '{:manPowerReqDetailID}'
    ).join(manpowerReqDetailId);

    // #30609: default to actually-active jobs (excludes closed + prospect);
    // the PM Dashboard "show all statuses" toggle passes false.
    url += '?$format=json&$count=true';
    url += `&activeJobsOnly=${activeJobsOnly}`;
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault.get(url) as Observable<
      IODataResult<ManPowerReqSupervisorDashboardDto>
    >;
  }

  public exportAllData(manpowerReqDetailId: string): Observable<any> {
    var url = GET_EXPORT_ALL_SUPERVISOR_DATA.split(
      '{:manPowerReqDetailID}'
    ).join(manpowerReqDetailId);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public queryManpowerPositionsStringFilterData(
    manpowerReqDetailId: string,
    fieldName: string,
    fieldQuery: string,
    top: number = 20,
    mustStartWith: boolean = false,
    activeJobsOnly: boolean = true
  ): Observable<IODataResult<ManPowerReqSupervisorDashboardDto[]>> {
    // sample: https://qa-sparta-api.azurewebsites.net/api/manpowers/supervisordashboard-odata/76be5ccc-4511-4f88-9fbf-b87ae5f32281?$count=true&$top=100&$apply=groupby((Supervisor),aggregate(ManPowerReqDetailID with countdistinct as groupTotal))&$filter=startswith(Supervisor, 'a')
    let url = GET_MANPOWER_POSITIONS_DATA_ODATA.split(
      '{:manPowerReqDetailID}'
    ).join(manpowerReqDetailId);

    // #30609: keep the group counts consistent with the grid's active-jobs filter.
    url += `?$count=true&activeJobsOnly=${activeJobsOnly}&$apply=groupby((${fieldName}),aggregate(ManPowerReqDetailID with countdistinct as total))`;
    if (fieldQuery) {
      if (mustStartWith)
        url += `&$filter=startswith(tolower(${fieldName}), tolower('${fieldQuery}'))`;
      else
        url += `&$filter=contains(tolower(${fieldName}), tolower('${fieldQuery}'))`;
    }

    return this.spartaApiHttpDefault.get(url) as Observable<
      IODataResult<ManPowerReqSupervisorDashboardDto[]>
    >;
  }

  public searchJobs(search: string, active: boolean = true): Promise<JobDto[]> {
    let url =
      GET_JOBS + '/?searchString=' + encodeURI(search) + '&status=' + active;
    return this.spartaApiHttpDefault
      .get<JobDto[]>(url)
      .toPromise()
      .then(parseData);
  }

  public getRequestedClasses(
    vpCompanyID: number
  ): Observable<RequestedClassDto[]> {
    return this.searchRequestedClasses(vpCompanyID, null);
  }

  public searchRequestedClasses(
    vpCompanyID: number,
    search: string | null
  ): Observable<RequestedClassDto[]> {
    const searchString = search ? `&searchString=${encodeURI(search)}` : '';
    const url = `${GET_REQUESTED_CLASSES}?vpCompanyID=${vpCompanyID}${searchString}`;
    return this.spartaApiHttpDefault.get<RequestedClassDto[]>(url);
  }

  public searchDispatchClasses(
    manPowerReqDetailID: string,
    search: string
  ): Promise<any[]> {
    let url = GET_DISPATCH_CLASSES.split('{:manpowerReqDetailId}').join(
      manPowerReqDetailID
    );
    url = url.split('{:searchString}').join(search);
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .toPromise()
      .then(parseData);
  }

  public saveManpowerReqDetails(
    items: SaveUpdateManPowerReqDetailDto[]
  ): Promise<any> {
    const url = '/api/manpowers/pm-dashboard';
    return this.spartaApiHttpDefault.post(url, items).toPromise();
  }

  public deleteManpowerReqDetails(itemGuids: any[]) {
    let url = '/api/manpowers/pm-dashboard';
    let options = { body: itemGuids };
    return this.spartaApiHttpDefault
      .request('delete', url, options)
      .toPromise();
  }

  public fetchWorkClasses(odataString: string) {
    let url = FETCH_WORKCLASSES;

    url += '?$format=json&$count=true';
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault.get(url).toPromise().then(parseData);
  }

  public fetchSimilarProspects(id: string): Promise<SimilarProspect[]> {
    var url = GET_SIMILAR_PROSPECTS.split('{:ID}').join(id);
    return this.spartaApiHttpDefault
      .get<SimilarProspect[]>(url)
      .toPromise()
      .then(parseData);
  }

  public fetchMatchingEmployees(id: string): Promise<any[]> {
    var url = GET_MATCHING_EMPLOYEES.split('{:ID}').join(id);
    return this.spartaApiHttpDefault
      .get<any[]>(url)
      .toPromise()
      .then(parseData);
  }

  public mergeProspect(
    prospectModel: ProspectModel,
    prospectIdToMerge: string
  ): Promise<ProspectSaveResult> {
    let url = MERGE_PROSPECT.split('{:ID}').join(prospectIdToMerge);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let body = JSON.stringify(prospectModel);
    return this.spartaApiHttpDefault
      .put<ProspectSaveResult>(url, body, options)
      .toPromise()
      .then(parseData);
  }

  public fetchPlants(
    searchString: string,
    take: number = 0,
    vpCompanyID: number = null,
    minLength: number = 2
  ): Promise<PlantDropdownDto[]> {
    if (vpCompanyID || (searchString && searchString.length >= minLength)) {
      let url = GET_PLANTS;
      let queryParams = '';

      if (searchString) queryParams += 'searchString=' + searchString;

      if (vpCompanyID)
        queryParams +=
          (queryParams.length > 0 ? '&' : '') + 'vpCompanyID=' + vpCompanyID;

      if (take) queryParams += '&take=' + take;

      return this.spartaApiHttpCamel
        .get<PlantDropdownDto[]>(url + queryParams)
        .toPromise()
        .then(parseData);
    } else {
      return of([]).toPromise();
    }
  }

  // TODO: eventually get rid of this completely if possible
  public fetchPlantsPascalCase(
    searchString: string,
    take: number = 0,
    vpCompanyID: number = null,
    minLength: number = 2
  ): Promise<PlantDropdownDto[]> {
    if (vpCompanyID || (searchString && searchString.length >= minLength)) {
      let url = GET_PLANTS;
      let queryParams = '';

      if (searchString) queryParams += 'searchString=' + searchString;

      if (vpCompanyID)
        queryParams +=
          (queryParams.length > 0 ? '&' : '') + 'vpCompanyID=' + vpCompanyID;

      if (take) queryParams += '&take=' + take;

      return this.spartaApiHttpDefault
        .get<PlantDropdownDto[]>(url + queryParams)
        .toPromise()
        .then(parseData);
    } else {
      return of([]).toPromise();
    }
  }

  public fetchScoreCardDropdownsData(
    manpowerReqDetailId: string
  ): Observable<any> {
    var url = GET_SCORE_CARD_DROPDOWNS_DATA.split(
      '{:manPowerReqDetailID}'
    ).join(manpowerReqDetailId);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public queryScoreCardChartDataByWeeks(
    weeksCount: number,
    queryString: string
  ): Observable<any> {
    var url = GET_SCORE_CARD_DATA_BY_WEEKS.split('{:weeksCount}').join(
      weeksCount.toString()
    );

    url += queryString;

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public queryScoreCardChartDataByDates(
    startDate: Date,
    endDate: Date,
    queryString: string
  ): Observable<any> {
    var url = GET_SCORE_CARD_DATA_BY_DATES;

    if (queryString) {
      url += queryString + '&';
    } else {
      url += '?';
    }

    if (startDate) {
      url += 'startDate=' + startDate.toISOString();
    }
    if (endDate) {
      url += '&endDate=' + endDate.toISOString();
    }

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public getEmployeesAroundPlantOdata(odataQuery: string): Observable<unknown> {
    var url = GET_EMPLOYEES_AROUND_PLANT_ODATA;
    url += '?$format=json&$count=true&';
    url += odataQuery;

    return this.spartaApiHttpDefault
      .get<unknown>(url)
      .pipe(map((data) => parseData(data)));
  }

  public getEmployeesAroundPlantPerfOdata(
    queryString: string,
    odataString: string
  ): Observable<any> {
    var url = GET_EMPLOYEES_AROUND_PLANT_PERF_ODATA;
    url += queryString;
    url += '$format=json&$count=true&';
    url += odataString;

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public getJobsEmployeesMap(
    vpCompanyId: number,
    day: Date,
    employeeId?: string,
    hrRef?: number
  ): Observable<any> {
    let url = GET_JOBS_EMPLOYEES_MAP;
    const dayOnly = this.toDateOnly(day);

    url +=
      '?' +
      getQueryParametersString(
        {
          vpCompanyId: vpCompanyId,
          day: dayOnly,
          employeeId: employeeId ?? null,
          hrRef: hrRef ?? null,
        },
        true
      );

    return this.spartaApiHttpCamel
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public getJobsEmployeesMapJobDetails(
    jobId: string,
    day: Date
  ): Observable<any> {
    let url = GET_JOBS_EMPLOYEES_MAP_JOB_DETAILS.split('{:jobId}').join(jobId);
    url +=
      '?' +
      getQueryParametersString(
        {
          day: this.toDateOnly(day),
        },
        true
      );

    return this.spartaApiHttpCamel
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public getJobsEmployeesMapOpeningCandidates(
    jobId: string,
    day: Date,
    jobClassId?: number,
    requestedTradeClassId?: string,
    requestedLinkedClassId?: string
  ): Observable<any> {
    let url =
      GET_JOBS_EMPLOYEES_MAP_OPENING_CANDIDATES.split('{:jobId}').join(jobId);
    url +=
      '?' +
      getQueryParametersString(
        {
          day: this.toDateOnly(day),
          jobClassId: jobClassId ?? null,
          requestedTradeClassId: requestedTradeClassId ?? null,
          requestedLinkedClassId: requestedLinkedClassId ?? null,
        },
        true
      );

    return this.spartaApiHttpCamel
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  /**
   * Unavailability blocks (PTO, medical, personal, …) overlapping [start, end].
   * PascalCase response, matching the C# PersonUnavailabilityDto.
   */
  public getUnavailability(
    start: Date | string,
    end: Date | string
  ): Observable<PersonUnavailabilityDto[]> {
    let url = GET_UNAVAILABILITY;
    url +=
      '?' +
      getQueryParametersString(
        {
          start: start instanceof Date ? start.toISOString() : start,
          end: end instanceof Date ? end.toISOString() : end,
        },
        true
      );

    return this.spartaApiHttpDefault
      .get<PersonUnavailabilityDto[]>(url)
      .pipe(map((data) => parseData(data)));
  }

  /** Create an unavailability block; Data carries the new PersonUnavailabilityID. */
  public createUnavailability(
    dto: SavePersonUnavailabilityDto
  ): Observable<BaseResponse<string>> {
    return this.spartaApiHttpDefault
      .post<BaseResponse<string>>(POST_UNAVAILABILITY, dto)
      .pipe(map((response) => parseData(response)));
  }

  /** Patch an unavailability block; only the provided fields change (BActive=false soft-deletes). */
  public updateUnavailability(
    personUnavailabilityId: string,
    dto: UpdatePersonUnavailabilityDto
  ): Observable<BaseResponse<boolean>> {
    const url = PUT_UNAVAILABILITY.split('{:id}').join(personUnavailabilityId);
    return this.spartaApiHttpDefault
      .put<BaseResponse<boolean>>(url, dto)
      .pipe(map((response) => parseData(response)));
  }

  private toDateOnly(day: Date | null | undefined): string | null {
    if (!day) {
      return null;
    }

    return `${day.getFullYear()}-${(day.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
  }

  public fetchComplianceOdata(
    backgroundMemberID: string,
    odatastring: string,
    isPreOnSite: boolean = false
  ): Observable<any> {
    var url =
      GET_COMPLIANCE_ODATA +
      '?backgroundMemberID=' +
      backgroundMemberID +
      '&isPreOnSite=' +
      isPreOnSite +
      '&';

    url += '$format=json&$count=true';
    url += odatastring ? '&' + odatastring : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public fetchComplianceCounts(backgroundMemberID: string): Observable<any> {
    var url = GET_COMPLIANCE_COUNTS.split('{:ID}').join(backgroundMemberID);

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data)));
  }

  public getSupervisors(jobIds: string[]): Promise<string[]> {
    return this.spartaApiHttpDefault
      .post<string[]>(GET_SUPERVISORS, jobIds ?? [])
      .toPromise()
      .then(parseData);
  }

  public getFilledBy(): Promise<FilledByOption[]> {
    return this.spartaApiHttpDefault
      .get<FilledByOption[]>(GET_FILLEDBY)
      .toPromise()
      .then(parseData);
  }

  public getForemans(jobIds: string[]): Promise<string[]> {
    return this.spartaApiHttpDefault
      .post<string[]>(GET_FOREMANS, jobIds ?? [])
      .toPromise()
      .then(parseData);
  }

  public getResourceCounts(
    dispatchStatusIDs: number[],
    dateFrom: Date,
    dateTo: Date
  ): Promise<ResourceCount[]> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let dto = {
      DispatchStatusIDs: dispatchStatusIDs,
      ResourceType: 'recruiter',
      DateFrom: dateFrom,
      DateTo: dateTo,
    };
    let body = JSON.stringify(dto);
    return this.spartaApiHttpDefault
      .put<ResourceCount[]>(GET_RESOURCE_COUNTS, body, options)
      .toPromise()
      .then(parseData);
  }

  public getRecruiterDispatchStatusCounts(
    dateFrom: Date,
    dateTo: Date
  ): Promise<RecruiterDispatchStatusCount[]> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let dto = {
      DateFrom: dateFrom,
      DateTo: dateTo,
    };
    let body = JSON.stringify(dto);
    return this.spartaApiHttpDefault
      .put<
        RecruiterDispatchStatusCount[]
      >(GET_RECRUITER_DISPATCH_STATUS_COUNTS, body, options)
      .toPromise()
      .then(parseData);
  }

  public queryLodgingData(odataString: string): Observable<FilterData> {
    var url = GET_LODGING_DATA_ODATA;

    url += '?$format=json&$count=true';
    url += odataString ? '&' + odataString : '';

    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData<FilterData>(data)));
  }

  public getLodgeReservation(
    lodgeReservationID: string
  ): Observable<LodgeReservationDto> {
    const url = GET_LODGE_RESERVATION.split('{:lodgeReservationID}').join(
      lodgeReservationID
    );
    return this.spartaApiHttpDefault
      .get(url)
      .pipe(map((data) => parseData(data) as LodgeReservationDto));
  }

  public getLodgeReservationByManPowerID(
    manPowerReqDetailID: string
  ): Promise<LodgeReservationDto> {
    const url = GET_LODGE_RESERVATION_BY_MAN_POWER_ID.split(
      '{:manPowerReqDetailID}'
    ).join(manPowerReqDetailID);
    return this.spartaApiHttpDefault
      .get<LodgeReservationDto>(url)
      .toPromise()
      .then(parseData);
  }

  public saveLodgeReservation(
    model: LodgeReservationDto
  ): Promise<LodgeReservationDto> {
    const url = SAVE_LODGE_RESERVATION;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return this.spartaApiHttpDefault
      .post<LodgeReservationDto>(url, model, options)
      .toPromise()
      .then(parseData);
  }

  public saveLodgeReservations(model: LodgeReservationDto[]) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    return this.spartaApiHttpDefault.post(
      '/api/manpowers/multiple/lodgeReservation',
      model,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      }
    );
  }

  public getLodges(): Promise<any[]> {
    return this.spartaApiHttpDefault
      .get<any[]>(GET_LODGES)
      .toPromise()
      .then(parseData);
  }

  public getRegions(): Promise<any[]> {
    return this.spartaApiHttpDefault
      .get<any[]>(GET_REGIONS)
      .toPromise()
      .then(parseData);
  }

  public searchEmployees(searchFields): Promise<{ value: any[] }> {
    let url = SEARCH_EMPLOYEES + '$format=json&$top=20&$count=true';

    if (searchFields.requestedClass) {
      url += '&requestedClassName=' + searchFields.requestedClass;
    }

    if (searchFields.requestedExpertises.length) {
      for (const expertiseId of searchFields.requestedExpertises) {
        url += '&expertiseId=' + expertiseId;
      }
    }

    if (searchFields.jobStartDate) {
      url +=
        '&jobStartDate=' +
        searchFields.jobStartDate.toLocaleDateString('en-US');
    }

    if (searchFields.jobEndDate) {
      url +=
        '&jobEndDate=' + searchFields.jobEndDate.toLocaleDateString('en-US');
    }

    if (searchFields.companies.length) {
      for (const company of searchFields.companies) {
        url += '&employeeVpCompanyId=' + company;
      }
    }

    return this.spartaApiHttpDefault
      .get<{ value: any[] }>(url)
      .toPromise()
      .then(parseData);
  }

  public bulkEditBadgeRequest(manpowerReqDetailIds: string[]) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.spartaApiHttpDefault.put(
      '/api/manpowers/bulkEditBadgeRequest',
      manpowerReqDetailIds,
      options
    );
  }
}
